import React from "react";
import MuiHeader from "@material-ui/core/TableHead";
import withStyles from "../../../styles/withStyles";

function Header(props) {
  return <MuiHeader {...props} />;
}

let styles = theme => ({
  root: {
    borderBottom: `2px solid ${theme.palette.secondary.main}`
  }
});

export default withStyles(styles)(Header);
